import React from 'react';
import { useAuth } from '../../../features/auth/contexts/useAuth';
import { NotificationCenter } from './NotificationCenter';
import { NavbarLogo } from './NavbarLogo';
import { DesktopNavigation } from './DesktopNavigation';
import { UserMenu } from './UserMenu';
import { AuthButtons } from './AuthButtons';
import { MobileMenu } from './MobileMenu';
import { useNavigation } from './useNavigation';
export const Navbar: React.FC = () => {
  const { logout } = useAuth();
  const {
    isNavVisible,
    mobileMenuOpen,
    setMobileMenuOpen,
    userMenuOpen,
    setUserMenuOpen,
    handleSignIn,
    getMainNavItems,
    isDashboardPage,
    user,
    isAuthenticated,
  } = useNavigation();

  const mainNavItems = getMainNavItems();



  return (
    <header
      className={`fixed top-3 left-0 right-0 z-50 transition-all duration-500 ease-in-out ${isNavVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0'}`}
      style={{ zIndex: 100 }}
    >
      <nav className="max-w-7xl mx-auto px-4 sm:px-6">
        {/* Conditional Navbar Styling - Desktop Only */}
        <div className={`${isDashboardPage ? 'lg:bg-gray-50 lg:border-0 lg:shadow-none lg:px-0 bg-white/90 border border-gray-200 rounded-xl shadow-md' : 'bg-white/90 border border-gray-200 rounded-xl shadow-md'} px-6 py-4 transition-all duration-500 ease-in-out`}>
          <div className="flex items-center justify-between">
            {/* Left Section - Logo */}
            <NavbarLogo isDashboardPage={isDashboardPage} />

            {/* Middle Section - Navigation (Desktop Only) */}
            <DesktopNavigation 
              mainNavItems={mainNavItems} 
              isDashboardPage={isDashboardPage} 
            />

            {/* Right Section - Auth/User Menu (Desktop Only) */}
            <div className="hidden lg:flex items-center gap-3 ml-auto">
              {/* Authenticated User Menu */}
              {isAuthenticated ? (
                <>
                  {/* Notification Center */}
                  <NotificationCenter />
                  
                  {/* User Menu */}
                  <UserMenu
                    user={user}
                    userMenuOpen={userMenuOpen}
                    setUserMenuOpen={setUserMenuOpen}
                    isDashboardPage={isDashboardPage}
                    logout={logout}
                  />
                </>
              ) : (
                /* Auth Buttons for Non-Authenticated Users */
                <AuthButtons onSignIn={handleSignIn} />
              )}
            </div>

            {/* Mobile Menu and Notification Bell - Only on smaller screens */}
            <div className="lg:hidden flex items-center gap-2">
              {/* Notification Center */}
              {isAuthenticated && <NotificationCenter />}
              
              {/* Mobile Menu */}
              <MobileMenu
                mobileMenuOpen={mobileMenuOpen}
                setMobileMenuOpen={setMobileMenuOpen}
                isDashboardPage={isDashboardPage}
                isAuthenticated={isAuthenticated}
                user={user}
                mainNavItems={mainNavItems}
                handleSignIn={handleSignIn}
                logout={logout}
              />
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};
